import { Component, OnInit } from '@angular/core';
import { CustomerAddress, CustomerInput } from '../../models/customer.model';
import { CustomerService } from '../../services/customer.service';
import { Router } from '@angular/router';
import { StorageService } from '../../services/storage.service';
import { LOCAL_STORAGE } from '../../constants/local-storage.constants';
import { AlertController, ModalController } from '@ionic/angular';
import { AddAddressProfileComponent } from './add-address-profile/add-address-profile.component';

@Component({
  selector: 'simpayx-addresses',
  templateUrl: './addresses.component.html',
  styleUrls: ['./addresses.component.scss'],
})
export class AddressesComponent implements OnInit {
  customerDetails: CustomerInput;
  addresses: CustomerAddress[];
  isLoading: boolean = true;
  backHref: string;

  constructor(
    private customerService: CustomerService,
    private storageService: StorageService,
    private modalController: ModalController,
    private alertController: AlertController
  ) {}

  ngOnInit() {
    this.getCustomerDetails();
    this.getBusinessIdMerchantIdFromLocal();
  }

  getCustomerDetails() {
    this.customerService.getCustomerAsObservable().subscribe((data) => {
      if (data) {
        if (typeof data === 'string') {
          const parsedData: CustomerInput = JSON.parse(data);
          this.customerDetails = parsedData;
        } else {
          this.customerDetails = data;
        }
        this.addresses = this.customerDetails.address;
        this.isLoading = false;
      }
    });
  }

  getBusinessIdMerchantIdFromLocal() {
    const businessId = this.storageService.getLocalStorageData(
      LOCAL_STORAGE.BUSINESS_VALUES
    ).businessId;
    const merchantId = this.storageService.getLocalStorageData(
      LOCAL_STORAGE.BUSINESS_VALUES
    ).merchantId;
    const baseUrl = 'simpayx/logistic';
    const queryParams = `merchantId=${merchantId}&businessId=${businessId}`;
    this.backHref = `${baseUrl}?${queryParams}`;
  }

  async openAddressModal(addressToEdit?: CustomerAddress) {
    const modal = await this.modalController.create({
      component: AddAddressProfileComponent,
      componentProps: {
        customerDetails: this.customerDetails,
        addresses: this.addresses,
        addressToEdit: addressToEdit
      },
      backdropDismiss: false,
    });
    modal.present();

    const { data } = await modal.onWillDismiss();
    if (data && data.updatedAddressList) {
        this.addresses = data.updatedAddressList;
    }
  }

  updateAddress(address: CustomerAddress){
    this.openAddressModal(address);
  }

  async confirmDeletion(addressToDelete: CustomerAddress){
    const alert = await this.alertController.create({
      header: 'Confirm Delete',
      message: 'Are you sure you want to delete this address?',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          handler: () => {
          }
        },
        {
          text: 'Delete',
          handler: () => {
            this.deleteAddress(addressToDelete);
          }
        }
      ]
    });

    await alert.present();
  }

  async deleteAddress(address: CustomerAddress) {
    const index = this.customerDetails.address.findIndex(
      (addr) => addr.id === address.id
    );
  
    if (index > -1) {

      const updatedAddresses = [...this.customerDetails.address];
      updatedAddresses.splice(index, 1);
      this.customerDetails = { ...this.customerDetails, address: updatedAddresses };
  
      this.customerService.updateCustomer(this.customerDetails.id, this.customerDetails)
        .subscribe({
          next: (data) => {
            this.addresses = updatedAddresses;
            console.log(this.addresses);
            this.showDeletionSuccessAlert();
            console.log("Updated customer details",this.customerDetails);
            this.customerService.setCustomerDetails(this.customerDetails);
          },
          error: (error) => {
            this.presentErrorAlert(error);
            this.customerDetails.address = [...this.customerDetails.address, address];
          }
        });
    } else {
      console.error('Address not found');
    }
  }
  
  async showDeletionSuccessAlert() {
    const alert = await this.alertController.create({
      header: 'Success',
      message: 'Address deleted successfully.',
      buttons: ['OK']
    });

    await alert.present();
  }

  async presentErrorAlert(error: any) {
    const alert = await this.alertController.create({
      header: 'Error',
      message: 'An error occurred while deleting the address: ' + error.message,
      buttons: ['OK']
    });
    await alert.present();
  }
  
}
